export const arr_sample_data = [
  {
    'img':'{{baseurl}}sampledata/img/sample-slider--sample-wall.jpg',
    'name':'sample-wall',
    'label':'Sample wall',
    'type':'simple',
  },
  {
    'img':'{{baseurl}}sampledata/img/sample-slider--outer-bottom-with-scroll-menu.jpg',
    'name':'outer-bottom-with-scroll-menu',
    'label':'Outer bottom with scroll menu',
    'type':'simple',
  },
  {
    'img':'{{baseurl}}sampledata/img/gallery-with-laptop-players.jpg',
    'name':'gallery-with-laptop-players',
    'label':'Laptop with Menu Right',
    'type':'complete',
  },
  {
    'img':'https://i.imgur.com/dBOBmOx.jpg',
    'name':'gallery-selector-with-dropdown',
    'label':'Select gallery with dropdown',
    'type':'complete',
  }
];